import { useContext } from 'react';
// Deep import: reads next/router's context without throwing when unmounted.
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';
export const useRouterContext = () => useContext(RouterContext);
